var _circle, _circle2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlanet = function SvgPlanet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 38,
    fill: "#E5F4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48,
    r: 38,
    fill: "url(#paint0_linear_574_25639)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.5 55C40.2614 55 42.5 52.7614 42.5 50C42.5 47.2386 40.2614 45 37.5 45C34.7386 45 32.5 47.2386 32.5 50C32.5 52.7614 34.7386 55 37.5 55Z",
    fill: "#82B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.369 57.3191C42.4131 64.7992 29.9714 70.2717 20.345 73.0829C15.524 74.4907 11.4641 75.2146 8.42279 75.2148C5.29623 75.215 3.62899 74.4581 3.00414 73.3758C2.3793 72.2936 2.55742 70.4712 4.12088 67.7636C5.64171 65.1299 8.29854 61.9758 11.9282 58.5047C19.176 51.5735 30.1362 43.535 43.0921 36.0549C56.0481 28.5747 68.4897 23.1022 78.1162 20.2911C82.9371 18.8832 86.997 18.1594 90.0383 18.1592C93.1649 18.159 94.8322 18.9159 95.457 19.9981C96.0818 21.0804 95.9037 22.9027 94.3403 25.6103C92.8194 28.2441 90.1626 31.3981 86.5329 34.8693C79.2851 41.8005 68.325 49.839 55.369 57.3191Z",
    stroke: "url(#paint1_angular_574_25639)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 53C27.8137 53 30.5 50.3137 30.5 47C30.5 43.6863 27.8137 41 24.5 41C21.1863 41 18.5 43.6863 18.5 47C18.5 50.3137 21.1863 53 24.5 53Z",
    fill: "url(#paint2_radial_574_25639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_574_25639",
    x1: 10.5,
    y1: 45.3611,
    x2: 86.5,
    y2: 50.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_574_25639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2306 46.687) rotate(150) scale(54.3777 13.2769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#82B1FF",
    stopOpacity: 0.743802
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#82B1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#82B1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#82B1FF",
    stopOpacity: 0.966583
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_574_25639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8394 44.6901) rotate(26.565) scale(9.16839 9.16839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlanet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "planet.672db020ba8451b70373e8d0fb9d0e94.svg";